<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row p-0 m-0 mb-3">
      <div class="col-2 col-md-3 p-0 m-0">
        <button type="button" class="btn btn-danger btn-float rounded-pill startbutton" style="position:relative;border-width:0px;" v-bind:style="getIconStyle(selectedview)" data-toggle="dropdown">
          <i class="icon-plus3" v-if="selectedview == null"></i>
          <i class="icon-pin-alt" v-if="selectedview == 'locations'"></i>
          <i class="icon-calendar3" v-if="selectedview == 'shifts'"></i>
          <i class="icon-users4" v-if="selectedview == 'teams'"></i>
          <i class="icon-users4" v-if="selectedview == 'users'"></i>
          <i class="icon-users4" v-if="selectedview == 'status'"></i>
          <i class="icon-users" v-if="selectedview == 'teamusers'"></i>
          <div class="" style="position: absolute; top: 100%; color: black;left: 0px; text-align: center; width:100%;">{{title}}</div>
        </button>

        <div class="dropdown-menu">
          <a class="dropdown-item" v-show="users.length>0" data-boundary="viewport" @click="createUserTabs"> {{$t('users')}}</a>
          <a class="dropdown-item" data-boundary="viewport" @click="createStatusTabs"> {{$t('status')}}</a>
          <a class="dropdown-item" v-show="locations.length>0" data-boundary="viewport" @click="createLocationTabs"> {{$t('location')}}</a>
          <a class="dropdown-item" v-show="shifts.length>0" data-boundary="viewport" @click="createShiftTabs">{{$t('shifts')}}</a>
          <a class="dropdown-item" v-show="teams.length>0" data-boundary="viewport" @click="createTeamsTabs">{{$store.translate('teams')}}</a>
          <div class="dropdown-submenu" v-show="teams.length>0">
            <a href="#" style="" class="dropdown-item dropdown-toggle">{{$store.translate('team_users')}}</a>
            <div class="skinnedmenu dropdown-menu mobile-submenu" style="position:relative;">
              <a v-bind:style="getdisplay(menuItem)" @click="createTeamsUsersTabs(menuItem.data, menuItem.text)" class="dropdown-item" v-for="menuItem in teams">{{ menuItem.text }}</a>
            </div>
          </div>
          <div class="dropdown-submenu" style="display:none">
            <a href="#" class="dropdown-item dropdown-toggle" @click="loadUsers">{{$t('user')}}</a>
            <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
              <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                <input type="text" class="form-control form-control" v-model="userFilter" @input="filterUsers" placeholder="filter">
                <div class="form-control-feedback form-control-feedback">
                  <i class="icon-search4"></i>
                </div>
              </div>
              <a v-bind:style="getdisplay(menuItem)" @click="addTabButton('user',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in users">{{ menuItem.text }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-9 col-md-9 p-0 m-0 mb-3 pt-2 pt-md-0 pr-3 pr-md-0">
        <div class="custom-button-row">
          <simple-carousel ref="car">
            <button style="position:relative" v-for="(tab, index) in tabs" v-bind:id="'tab-type' + tab.type + '-data' + tab.data" :key="'tab-type' + tab.type + '-data' + tab.data" @click="tabClick(tab)" type="button" class="hidden btn btn-danger btn-float rounded-pill round-tab mr-2 mr-md-4 custom-tab-button"  v-bind:style="getTabstyle(tab)">
              <i class="icon-pin-alt" v-if="selectedview == 'locations'"></i>
              <i class="icon-calendar3" v-if="selectedview == 'shifts'"></i>
              <i class="icon-users4" v-if="selectedview == 'teams'"></i>
              <img v-if="selectedview == 'teamusers'" v-bind:src="'/api/membership/GetSquareImage?username=' + tab.data" class="rounded-circle" alt="" height="65" width="65">
              <div href="#" class="custom-btn-label" style="position:absolute;color: black; font-size: 10px; padding-left: 3px; padding-right: 3px; line-height: 10px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block;" v-bind:style="getTabTextstyle(tab)">{{tab.text}}</div>
            </button>
          </simple-carousel>
        </div>
      </div>
    </div>
    <div class="row mt-3 mt-md-5" v-show="displayDateSelector == true">
      <div class="col-12">
        <viewmaker-date-selector ref="dateSelector" @changed="changedDate"></viewmaker-date-selector>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 px-0">
        <viewmaker-tableview ref="viewmakertableview" @changed="changedDateFromUserCard" v-for="(filter, index) in filters" v-bind:style="'z-index:' + (100-index) +';position:relative;'" v-bind:headerdata="headerdata" v-bind:rowclick="rowclick" v-bind:togglestatus="togglestatus" v-bind:multiplerowclick="multiplerowclick" :key="filter.id" v-bind:filter="filter"></viewmaker-tableview>
      </div>
    </div>
    <div class="row p-0 m-0 mt-1" v-if="activeTab != null" style="display:none;">
      <div class="col-12 p-0 m-0">
        <button type="button" class="btn btn-outline-secondary btn-icon rounded-pill" @click="addTable()">
          <i class="icon-plus3"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

  import tablePagination from "../carousel/simple-carousel.vue";
  import { nextTick } from 'vue'

  export default {
    name: 'viewmaker-tabs',
    components: {
      tablePagination
    },
    props: {

      rowclick: {
        required: false,
        type: String,
        default: ''
      },
      multiplerowclick: {
        required: false,
        type: String,
        default: ''
      },
      togglestatus: {
        required: false,
        type: String,
        default: ''
      },
    },
    data() {
      return {
        tabs: [],
        activeTab: null,
        filters: [],
        userFilter: '',
        users: [],
        dateFilter: { type: 'dateassignedorcreated', data: '', text: 'D' },
        locations: [],
        users: [],
        statuses: [],
        shifts: [],
        teams: [],
        displayDateSelector: false,
        selectedview: null,
        title: "Select a view",
        tabstyle: '',
        headerdata: [],
        defaultdisplay: 5,
      }
    },
    methods: {
      changedDateFromUserCard(startdate) {
        var date = this.$store.getMomentLocale(startdate).startOf('day');
        // We also need to change the date in the dateselector
        this.$refs.dateSelector.setDate(date);
        this.doFilterChange(date, date, this.activeTab);
      },
      changedDate(startdate, enddate) {
        var start = this.$store.getMomentLocale(startdate)
        var end = this.$store.getMomentLocale(enddate);
        this.doFilterChange(start, end, this.activeTab);
      },
      addTable() {
        this.filters.push({});
      },
      showTextBox(tab) {
        tab.textboxvisible = true;
        this.$forceUpdate();
      },
      hideTextBox(tab) {
        tab.textboxvisible = false;
        this.$forceUpdate();
      },
      addTabButton(type, data, text) {
        this.tabs.push({ type: type, data: data.toString(), text: text })
      },
      tabClick(tab) {

        if (this.activeTab == tab) {
          //alert("Is same")
          this.activeTab = null;
          this.displayDateSelector = false;
          this.filters = [];
          Vue.set(this, "filters", this.filters);
          return;
        }

        this.activeTab = tab;

        var dates = this.$refs.dateSelector.getDate();

        var start = this.$store.getMomentLocale(dates.startDate)
        var end = this.$store.getMomentLocale(dates.endDate);

        this.doFilterChange(start, end, tab);

      },

      doFilterChange(start, end, tab) {

        var childFilters = [];
        if (tab.type == "status") {
          //for (var i = 0; i < this.statuses.length; i++) {
          //  if (this.statuses[i].data == tab.data)
          //    childFilters.push(this.statuses[i]);
          //}
        }
        else
          childFilters = this.loadChildFilters(tab.type);

        var tmpFilter = [];

        
       
          
        // Add date filter

        var dateFilter = {
          id: this.generateQuickGuid(),
          type: 'dateassignedorcreated',
          data: start.format('YYYY-MM-DD') + "," + end.format('YYYY-MM-DD'),
          text: 'D'
        };

        if (childFilters.length > 0) {
          for (var i = 0; i < childFilters.length; i++) {

            tmpFilter.push(
              {
                id: this.generateQuickGuid(),
                type: tab.type,
                data: tab.data,
                text: tab.text,
                filters: [],
              }
            )
            // Add date filter to the "child" filter
            tmpFilter[i].filters.push(dateFilter);

            //Add child filter
            if (childFilters[i].type) {
              tmpFilter[i].filters.push(childFilters[i]);
            }
          }
        }
        else {
          tmpFilter.push(
            {
              id: this.generateQuickGuid(),
              type: tab.type,
              data: tab.data,
              text: tab.text,
              filters: [],
            }
          )

          //Add date filter as a "top" filter
          tmpFilter[0].filters.push(dateFilter);
          
        }

        this.displayDateSelector = true;
        this.filters = JSON.parse(JSON.stringify(tmpFilter));
        Vue.set(this, "filters", this.filters);
      },

      loadChildFilters(type) {
        if (type == "status") {
          return this.users;
        }
        else if (type == "location") {
          return this.shifts;
        }
        else if (type == "siteshift") {
          return this.locations;
        }
        else if (type == "team") {
          // A empty filter creates a row, but without adding a filter
          return [{}];
        }
        else if (type == "user") {
          // A empty filter creates a row, but without adding a filter
          return this.statuses;
        }
        else
          return [{}];

      },
      getLocationIds(parentid, data) {
        var arr = [parentid.toString()];
        for (var i = 0; i < data.length; i++) {
          if (data[i].ParentId == parentid)
            arr.push(data[i].locationid.toString());
        }
        return arr.join(",");
      },
      createStatusTabs() {
        this.filters = [];
        this.tabstyle = "background-color:#71BFA5; border-color:#71BFA5;";
        this.title = this.$store.translate("status")
        this.selectedview = 'status';
        this.tabs = this.statuses;
        Vue.set(this, "tabs", this.tabs);
        this.$forceUpdate();
        this.$refs.car.reset();
      },
      createUserTabs() {
        this.filters = [];
        this.tabstyle = "background-color:#71BFA5; border-color:#71BFA5;";
        this.title = this.$store.translate("users")
        this.selectedview = 'users';
        this.tabs = this.users;
        Vue.set(this, "tabs", this.tabs);
        this.$forceUpdate();
        this.$refs.car.reset();
      },
      createLocationTabs() {
        this.filters = [];
        this.tabstyle = "background-color:#71BFA5; border-color:#71BFA5;";
        this.title = this.$store.translate("locations")
        this.selectedview = 'locations';
        this.tabs = this.locations;
        Vue.set(this, "tabs", this.tabs);
        this.$forceUpdate();
        this.$refs.car.reset();
      },
      getElement(type, text, data) {
        var ret = "";
        ret += '<button style="position:relative" type="button" class="btn btn-danger btn-float rounded-pill round-tab mr-1 custom-tab-button viewmaker" >'
        ret += '<i class="icon-pin-alt"></i>'
        ret += '<div href="#" class="custom-btn-label" style="position: absolute; color: black;font-size: 10px;padding-left: 3px; padding-right: 3px; overflow-wrap: break-word; line-height: 10px;">' + text + '</div>';
        ret += '</button>';
        return ret;
      },
      loadUsers(activate) {
        try {

          this.$http.get('/api/Users/v1?').then(async response => {
            this.users = [];
            var tabs = [];

            for (var i = 0; i < response.data.length; i++) {

              tabs.push({ id: response.data[i].Username, type: "user", data: response.data[i].Username, text: response.data[i].Name, visible: true })

              this.users = tabs;
             
              this.filterUsers();

              if (activate == true) {
                this.createUserTabs();
              }

              this.$forceUpdate();

            }
          })

        } catch (err) {
          alert('some error:' + err)
        }
      },
      loadLocations(activate) {
        try {

          this.$http.get('/api/Locations/v1').then(async response => {

            var tabs = [];

            for (var i = 0; i < response.data.length; i++) {
              var ids = this.getLocationIds(response.data[i].locationid, response.data)
              if (response.data[i].ParentId == null) {

                // Only display 'top' locations
                tabs.push({ id: this.generateQuickGuid(), type: "location", data: ids, text: response.data[i].locationname, visible: true })
              }
              
            }

            
            this.locations = tabs;
            if (activate == true) {
              this.createLocationTabs();
            }

            this.$forceUpdate();

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },

      createShiftTabs() {
        this.filters = [];
        this.tabstyle = "background-color:#6AB1C8; border-color:#6AB1C8;";
        this.title = this.$t('shifts');
        this.selectedview = 'shifts';
        this.tabs = this.shifts;
        Vue.set(this, "tabs", this.tabs);
        this.$forceUpdate();
        this.$refs.car.reset();
      },
      LoadShifts() {
        try {

          this.$http.get('/api/Admin/v1/SiteShifts').then(async response => {

            var tabs = [];

            //response.data = response.data.sort(function (a, b) {
            //  var x = a.Name.toLowerCase();
            //  var y = b.Name.toLowerCase();
            //  return x < y ? -1 : x > y ? 1 : 0;
            //});

            for (var i = 0; i < response.data.length; i++) {
              tabs.push({ id: this.generateQuickGuid(), type: "siteshift", data: response.data[i].SiteShiftId, text: response.data[i].Name, visible: true })
             
            }

            this.shifts = tabs;
            
            this.$forceUpdate();

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      generateQuickGuid() {
        return Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15);
      },
      createTeamsTabs() {
        this.filters = [];
        this.tabstyle = "background-color:#A5D0DE; border-color:#A5D0DE;";
        this.title = this.$store.translate("teams")
        this.selectedview = 'teams';
        this.tabs = this.teams;
        Vue.set(this, "tabs", this.tabs);
        this.$forceUpdate();
        this.$refs.car.reset();
      },
      LoadTeams(activate) {
        try {

          this.$http.get('/api/Teams/v1?').then(async response => {

            var tabs = [];

            for (var i = 0; i < response.data.length; i++) {
              tabs.push({ id: this.generateQuickGuid(), type: "team", data: response.data[i].Id.toString(), text: response.data[i].Name, display: true, visible:true })
            
            }
            this.teams = tabs;

            if (activate == true) {
              this.createTeamsTabs();
            }

            this.$forceUpdate();

          });
        } catch (err) {
          alert('some error:' + err)
        }

      },

      createTeamsUsersTabs(id, name) {
        this.filters = [];
        this.tabstyle = "background-color:#8B9DB4; border-color:#8B9DB4;";
        this.title = this.$store.translate("team") + " " + name;
        this.selectedview = 'teamusers';
        this.tabs = [];
        Vue.set(this, "tabs", this.tabs);
        this.loadTeamUsers(id);
        
      },
      getdisplay(item) {
        if (item.display == true) {
          return "display:block";
        }
        return "display:none;"
      },
      async loadTeamUsers(teamid) {
        try {
          this.$http.get('/api/Team/Members/' + teamid).then(async response => {
            var teamusers = [];

            if (response.data !== null && response.data.length > 0) {

            } for (var i = 0; i < response.data.length; i++) {
              teamusers.push({ id: this.generateQuickGuid(), type: 'user', data: response.data[i].Name, text: response.data[i].Name, display: true })
            }

            this.tabs = teamusers;
            Vue.set(this, "tabs", this.tabs);
            this.$forceUpdate();

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      /*
      async loadUsers_old() {
        try {
          this.$http.get('/api/Membership/GetSiteUsers?').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.users.push({ id: this.generateQuickGuid(), username: response.data[i].Username, text: response.data[i].Name, display: true })
            }
            this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      */

      filterUsers() {
        var visibleItems = 0;
        for (var i = 0; i < this.users.length; i++) {
          if ((this.userFilter != null && this.userFilter != "" && this.users[i].text.toLowerCase().indexOf(this.userFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.users[i].display = false;
          }
          else {
            this.users[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "users", this.users);
      },
      getIconStyle(selectedview) {
        if (selectedview == 'locations') {
          
          return "background-color:#71BFA5"
        }
        else if(selectedview == 'teams'){
          return "background-color:#A5D0DE"
        }
        else if (selectedview == 'shifts') {
          return "background-color:#6AB1C8"
        }
        else if (selectedview == 'teamusers') {
          return "background-color:#8B9DB4"
        }
         
        return "background-color:#DDDDDD";
      },
      getTabstyle(tab) {
        if (tab == this.activeTab)
          return "float:left;" + this.tabstyle + ";background-color:#484848;border-color:#484848;";
        return "float:left;" + this.tabstyle;
      },
      getTabTextstyle(tab) {
        if (tab == this.activeTab)
          return "color:black;";
        return "color:#777";
        
      },
      clearSelected() {
        for (var ref in this.$refs) {
          if (ref.indexOf('viewmakertableview') > -1) {
            for (var i = 0; i < this.$refs[ref].length; i++) {
              this.$refs[ref][i].clearSelected()
            }
          }
        }
      },
      changeHeaderData(headerData) {
        this.headerdata = headerData;
      },
      getChunks(array, chunkSize) {
        var retChunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
          const chunk = array.slice(i, i + chunkSize);
          retChunks.push(chunk);
        }
        return retChunks;
      }
    },
    created() {

    },
    mounted() {

      this.statuses = [
        {
          "customstyle": "background-color:rgba(239, 193, 101, 0.8)",
          "customclass": "",
          "abbreviation": null,
          "data": 0,
          "text": this.$t("created"),
          "icon": null,
          "cssIcon": "icon-stack-star icon-2x",
          "key": "created",
          "type": "status"
        },
        {
          "customstyle": "background-color:rgba(131,189,166,0.8)",
          "customclass": "",
          "abbreviation": null,
          "data": 2,
          "text": this.$t("done"),
          "icon": null,
          "cssIcon": "icon-stack-check icon-2x",
          "key": "done",
          "type": "status"
        }
        ,
        {
          "customstyle": "background-color:rgba(237,125,49,0.8)",
          "customclass": "",
          "abbreviation": null,
          "data": 2,
          "text": this.$t("not_done"),
          "icon": null,
          "cssIcon": "icon-stack-cancel icon-2x",
          "key": "notstatus",
          "type": "notstatus"
        }]

      this.$root.$on('tableviewcolumnschanged', this.changeHeaderData);

      this.title = this.$t('select_a_view');
      if (this.$store.getInstallationType() == "Parking")
        this.loadLocations(true);
      else
        this.loadLocations(false);

      if (this.$store.getInstallationType() == "Education")
        this.LoadTeams(true);
      else
        this.LoadTeams(false);

      this.LoadShifts();
      
      this.loadUsers();

      this.headerdata = [
        { headername: this.$t('user'), columnname: "UserIcon", css: "", datahide: "", enabled: false, databreakpoints: "", hideheader: true },
        { headername: this.$t('check'), columnname: "QuickDone", css: "", datahide: "", enabled: true, databreakpoints: "", hideheader: true },
        { headername: "Id", columnname: "ProcedureScheduleId", css: "", datahide: "", enabled: false, databreakpoints: "", isId: true },
        { headername: "#", columnname: "TaskNumber", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('name'), columnname: "ProcedureSchuleName", css: "", datahide: "", enabled: true, databreakpoints: "" },
        { headername: this.$t('location'), columnname: "ParentLocation", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('sub_location'), columnname: "Location", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('date'), columnname: "DatescheduledString", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('team'), columnname: "TeamName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('status'), columnname: "Status", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('ready'), columnname: "ReadyState", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('time_estimated'), columnname: "EstimatedTime", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('time_spent'), columnname: "ActualTime", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('priority'), columnname: "Priority", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('project'), columnname: "ProjectName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('client'), columnname: "OrganisationName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('assigned_to'), columnname: "AssignTo", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('shift'), columnname: "ShiftName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('created'), columnname: "DateCreated", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('modified'), columnname: "DateModified", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('created_by'), columnname: "CreatedBy", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('response_time'), columnname: "ResponseTimeLable", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('resolution_time'), columnname: "ResolutionTimeLable", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: "ParentProcedureId", columnname: "ParentProcedureId", css: "", datahide: "", enabled: false, visible: false, databreakpoints: "" },
        { headername: this.$t('message_count'), columnname: "SchMessagesCount", css: "", datahide: "", enabled: true, databreakpoints: "", hideheader: true },
      ];

    },
    watch: {
      filters: function (newVal, oldVal) {
        //alert("Filters changed to:" + JSON.stringify(newVal));
        //this.$root.$emit('initfilter');
      },
    },
    computed: {
     
    }
  }
</script>

<style scoped>


  .active-tab {
    /*background-color: black;*/
    color: white;
    border-color: #35437F !important;
  }

  .round-tab{
      border-width:1px;
  }

  .active-tab:after {
    content: '\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.2);
    opacity: 1;
    transition: all 1s;
    -webkit-transition: all 1s;
    border-radius: 50rem !important;
  }











  .filter-badge {
    line-height: 10px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
  }

  .newplus-button {
    color: #666;
    background-color: white !important;
    margin-top: 16px;
    margin-left: 5px;
  }

    .newplus-button img {
      width: 60px;
      height: 60px;
      margin-top: 5px;
    }

  .button-icon {
    width: 60px;
    height: 60px;
  }



  .btn-outline:not(.disabled):not(:disabled):not([class*="alpha-"]):hover, .newplus-button i:hover, .newplus-button i:active, .newplus-button i:focus {
    color: #000 !important;
  }

  .mobile-submenu {
    left: 0px !important;
  }

  @media (min-width: 768px) {

    .button-icon {
      width: 80px;
      height: 80px;
    }

    .mobile-submenu {
      left: 100% !important;
      position: absolute !important;
    }


    .newplus-button {
      border-color: white !important;
      background-color: white !important;
      margin-left: 17px;
      margin-top: -4px !important;
    }
  }

  .expanded-container-collapsed {
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .expanded-container-active {
    opacity: 1;
    width: 100%;
    height: 200px;
    background-color: green;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -webkit-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -moz-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -o-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
  }

  /*
  .childComponentContainer .configurator {
    margin-left: 15px !important;
  }

  .childComponentContainer .configurator:nth-child(0) {
    margin-left: 0px !important;
  }
  */
  .startbutton {
    height: 100px;
    width: 100px;
  }

  div > .custom-tab-button:last-child{
      margin-right:0px !important;
  }

  .custom-tab-button > img {
    width: 54px;
    height: 54px;
    position: absolute;
    left: 2px;
    top: 2px;
  }

  .custom-btn-label {
    left: 0px;
    top: calc(5px + 100%);
    width: 60px;
    display: inline-grid;
    padding: 3px;
    text-align: center;
    overflow: hidden;
    border: 1px solid rgb(221, 221, 221);
    background-color:white;
  }

  .custom-button-row{

  }

  .custom-tab-button {
    height: 60px;
    width: 60px;
    margin-bottom: 22px;
  }

  .startbutton > i, .custom-tab-button {
    font-size: 2rem;
  }
    

  @media screen and (max-width:768px) {

    

    .newplus-button img {
      width: 46px;
      height: 46px;
      margin-top: 10px;
      margin-right: 14px;
    }
    .startbutton {
      height: 50px;
      width: 50px;
    }

    .custom-tab-button {
      max-height: 40px;
      max-width: 40px;
      padding: 0px !important;
      margin-bottom: 22px;
    }

      .custom-tab-button > img {
        width: 38px;
        height: 38px;
        position:absolute;
        left:0px;
        top:0px;
        padding: 0px !important;
      }

    .custom-button-row {
    }

    .custom-btn-label {
      left: 0px;
      width: 40px;
      height: 20px;
      overflow: hidden;
      display: inline-grid;
      padding: 3px;
      top: calc(5px + 100%);
    }

      .startbutton > i, .custom-tab-button {
        font-size: 18px;
      }

  }

</style>

<style>
  .btn-float.viewmaker {
    padding: 7px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/viewmaker/viewmaker-tabs.vue